import React from 'react';
import { Link } from 'react-router-dom';
import { useWallet } from '@solana/wallet-adapter-react';
import CreateCollectionForm from '../CreateCollectionForm';

export default function CreateCollectionPage() {
    const { publicKey } = useWallet();
    return <>
        <div className="detail-page-return-link-container">
            <Link className="muulti-button detail-page-return-link" to="/wallet-detail">Back to Admin</Link>
        </div>
        <CreateCollectionForm key={publicKey?.toBase58?.() || 'disconnected'} />
    </>;
}
